import { takeLatest, put } from 'redux-saga/effects';

import {
  getRequest,
  deleteRequest,
  handleThrowSubmissionError
} from '../../../utilities/requests';
import { showSuccessModal } from '../../../modules/ModalConductor/reducer';
import {
  DELETE_ALL_FAILED_MERCHANTS,
  LOAD_FAILED_MERCHANTS,
  setFailedMerchants,
  failedLoad,
  DELETE_FAILED_MERCHANT,
  setFailedMerchantDeleted
} from './ImportCsv/reducer';

function* handleLoadFailedMerchants() {
  try {
    const url = '/failed_merchant_registrations';
    const response = yield getRequest(url);
    yield put(setFailedMerchants(response.data.failed_merchant_registrations));
  } catch (error) {
    yield put(failedLoad());
  }
}

export function* loadFailedMerchantsSaga() {
  yield takeLatest(LOAD_FAILED_MERCHANTS, handleLoadFailedMerchants);
}

function* handleDeleteFailedMerchant(action) {
  try {
    const url = `/failed_merchant_registrations/${action.failedMerchantId}`;
    yield deleteRequest(url);
    yield put(setFailedMerchantDeleted(action.failedMerchantId));
    if (action.showModal) {
      yield put(
        showSuccessModal(
          'Merchant Deleted',
          'The merchant application has been successfully deleted.'
        )
      );
    }
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
}

export function* deleteFailedMerchantSaga() {
  yield takeLatest(DELETE_FAILED_MERCHANT, handleDeleteFailedMerchant);
}

function* handleDeleteAllFailedMerchants() {
  try {
    const url = '/failed_merchant_registrations/clear';
    yield deleteRequest(url);
    yield put(
      showSuccessModal(
        'Merchant Applications Delete',
        'Merchant Applications have been successfully deleted.'
      )
    );
    yield put(setFailedMerchants([]));
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
}

export function* deleteAllFailedMerchantsSaga() {
  yield takeLatest(DELETE_ALL_FAILED_MERCHANTS, handleDeleteAllFailedMerchants);
}
